"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var image_1 = require("@syl-editor/lib/dist/lib/formats/image");
var image_resize_box_1 = __importDefault(require("./image-resize-box"));
var core_utilities_1 = require("@syl-editor/core-utilities");
var tool_icons_1 = require("../../../modules/toolbar/tools/tool-icons");
var lodash_debounce_1 = __importDefault(require("lodash.debounce"));
var DEFAULT_IMG_SIZE;
(function (DEFAULT_IMG_SIZE) {
    DEFAULT_IMG_SIZE[DEFAULT_IMG_SIZE["width"] = 375] = "width";
    DEFAULT_IMG_SIZE[DEFAULT_IMG_SIZE["height"] = 300] = "height";
})(DEFAULT_IMG_SIZE || (DEFAULT_IMG_SIZE = {}));
var ImageMask = /** @class */ (function (_super) {
    __extends(ImageMask, _super);
    function ImageMask(props) {
        var _this = _super.call(this, props) || this;
        _this.isInline = false;
        _this.imageMount = false;
        _this.localeUpdate = lodash_debounce_1.default(function () { return _this.imageMount && _this.forceUpdate(); }, 300, {
            leading: true
        });
        _this._handleCheckStatus = function (e) {
            if (e.target &&
                _this.imageWrapDom &&
                e.target.tagName.toLowerCase() !== 'input' &&
                _this.imageWrapDom.contains(e.target) &&
                !_this.state.active) {
                _this.setState({ active: true });
            }
            else if (_this.state.active) {
                _this.setState({ active: false });
            }
        };
        _this.updateCaptionValue = function (e) {
            var caption = _this.state.caption;
            var _a = _this.props, adapter = _a.adapter, attrs = _a.attrs;
            adapter.enable();
            if (caption !== attrs.alt)
                _this.dispatchUpdate({ alt: caption });
        };
        _this.dispatchUpdate = function (attrs) {
            var pos = _this.props.getPos();
            if (pos === undefined)
                return;
            _this.props.adapter.updateCardAttrs(pos, attrs);
        };
        _this._onResizeEnd = function (width, height) {
            return _this.dispatchUpdate({
                width: width,
                height: height
            });
        };
        _this._changeAlt = function (e) {
            _this.setState({
                caption: e.target.value
            });
        };
        _this.renderPercent = function () {
            var uploadPercent = _this.props.uploadPercent;
            if (uploadPercent === void 0)
                return;
            return (react_1.default.createElement("span", { className: "syl-image-uploading-wrapper" },
                react_1.default.createElement("span", { className: "syl-uploading-percent-base" },
                    react_1.default.createElement("span", { className: "syl-uploading-percent", style: { width: uploadPercent + "%" } }))));
        };
        _this.renderImage = function () {
            var _a = _this.props, attrs = _a.attrs, uploadPercent = _a.uploadPercent, adapter = _a.adapter;
            var src = attrs.src, height = attrs.height, alt = attrs.alt, _b = attrs.width, width = _b === void 0 ? DEFAULT_IMG_SIZE.width : _b;
            var config = image_1.Image.ImageService.imageConfiguration;
            var active = _this.state.active;
            return (react_1.default.createElement("span", { className: "image-wrapper", ref: function (ref) { return _this.isInline && (_this.imageWrapDom = ref); } },
                react_1.default.createElement("img", { src: src, alt: alt || '', width: width, height: height || 'auto' }),
                adapter.editable &&
                    !config.disableResize &&
                    active &&
                    uploadPercent === void 0 ? (react_1.default.createElement(image_resize_box_1.default, { height: height || DEFAULT_IMG_SIZE.height, onResizeEnd: _this._onResizeEnd, editorDOM: adapter.view.dom, src: src, width: width })) : null));
        };
        _this.renderBlockImage = function () {
            var _a = _this.props, attrs = _a.attrs, adapter = _a.adapter;
            var align = attrs.align;
            var locale = adapter.configurator.getLocaleValue('image');
            var active = _this.state.active;
            var config = image_1.Image.ImageService.imageConfiguration;
            return (react_1.default.createElement("div", { ref: function (ref) { return (_this.imageWrapDom = ref); }, className: classnames_1.default('syl-image-wrapper'), style: { textAlign: align } },
                react_1.default.createElement("div", { className: "syl-image-fixer" },
                    active && adapter.isFocused && !config.disableAlign && (react_1.default.createElement("span", { className: "align-menu" },
                        react_1.default.createElement("span", { className: classnames_1.default('align-icon', { active: align === 'left' }), onClick: function () { return _this.dispatchUpdate({ align: 'left' }); } }, tool_icons_1.Icons.align_left),
                        react_1.default.createElement("span", { className: classnames_1.default('align-icon', { active: align === 'center' }), onClick: function () { return _this.dispatchUpdate({ align: 'center' }); } }, tool_icons_1.Icons.align_center),
                        react_1.default.createElement("span", { className: classnames_1.default('align-icon', { active: align === 'right' }), onClick: function () { return _this.dispatchUpdate({ align: 'right' }); } }, tool_icons_1.Icons.align_right))),
                    _this.renderImage(),
                    config.disableCaption !== true && (react_1.default.createElement("div", { className: "syl-image-caption" },
                        react_1.default.createElement("input", { type: "text", maxLength: config.maxLength || 20, placeholder: config.placeholder ||
                                locale.placeholder ||
                                "\u56FE\u7247\u63CF\u8FF0(" + config.maxLength + "\u5B57\u5185)", className: "syl-image-caption-input", draggable: true, onDragStart: function (e) {
                                e.preventDefault();
                                e.nativeEvent.stopImmediatePropagation();
                            }, onCopy: function (e) {
                                var selection = window.getSelection();
                                if (selection) {
                                    e.clipboardData.setData('text/html', selection.toString());
                                }
                            }, onFocus: function () { return adapter.disable(); }, onChange: _this._changeAlt, onMouseUp: function (e) { return e.nativeEvent.stopImmediatePropagation(); }, onBlur: _this.updateCaptionValue, value: _this.state.caption, onClick: function (e) {
                                e.stopPropagation();
                            } }))))));
        };
        var adapter = props.adapter, attrs = props.attrs;
        var schema = adapter.view.state.schema;
        _this.isInline = schema.nodes[image_1.Image.configuration.name].isInline;
        _this.updateImageUrl(props);
        _this.MAX_WIDTH = adapter.view.dom.scrollWidth - 40;
        _this.state = {
            caption: attrs.alt || '',
            active: false
        };
        return _this;
    }
    ImageMask.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (this.props.attrs.src !== nextProps.attrs.src) {
            this.updateImageUrl(nextProps);
        }
        if (nextProps.attrs.alt !== this.state.caption) {
            this.setState({
                caption: nextProps.attrs.alt || ''
            });
        }
    };
    ImageMask.prototype.componentDidMount = function () {
        document.addEventListener('click', this._handleCheckStatus);
        this.props.adapter.on(core_utilities_1.EventChannel.LocalEvent.LOCALE_CHANGE, this.localeUpdate);
        this.imageMount = true;
    };
    ImageMask.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this._handleCheckStatus);
        this.props.adapter.off(core_utilities_1.EventChannel.LocalEvent.LOCALE_CHANGE, this.localeUpdate);
        this.imageMount = false;
    };
    ImageMask.prototype.updateImageUrl = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                image_1.Image.ImageService.updateImageUrl(props, this.props.dispatchUpdate);
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ImageMask.prototype, "width", {
        get: function () {
            return (Math.min(this.props.attrs.width || 0, this.MAX_WIDTH) ||
                DEFAULT_IMG_SIZE.width);
        },
        enumerable: true,
        configurable: true
    });
    ImageMask.prototype.render = function () {
        return this.isInline ? this.renderImage() : this.renderBlockImage();
    };
    return ImageMask;
}(react_1.default.PureComponent));
exports.ImageMask = ImageMask;
//# sourceMappingURL=mask.js.map